import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

const validateCvv = value => ((/^\d{3}$/).test(value) ? undefined : true);
const validateAmount = value => (isNaN(parseFloat(value)) ? true : undefined);
const normalizeAmount = value => value.replace(/[^0-9.]/g, '');

const validateAmountLength = (event) => {
    if (event.target.value > 99999.99) {
        event.preventDefault();
    }
};

export class TopUpForm extends Component {
    constructor(props) {
        super(props);
        this.onAmountBlur = this.onAmountBlur.bind(this);
        this.onCvvBlur = this.onCvvBlur.bind(this);
    }

    onCvvBlur(e, newValue) {
        e.preventDefault();
        const isCvvInvalid = validateCvv(newValue);
        if (isCvvInvalid) {
            const { change } = this.props;
            change('cv2', '');
        }
    }

    onAmountBlur(e, newValue) {
        e.preventDefault();
        const isAmountInvalid = validateAmount(newValue);
        const { change } = this.props;
        const val = isAmountInvalid ? '' : parseFloat(newValue).toFixed(2);
        change('amount', val);
    }

    render() {
        const {
            handleSubmit,
            cardNumber,
            currencySign,
        } = this.props;
        const formattedCardNumber = cardNumber
            ? Array(3).fill('\u2022'.repeat(4)).join(' ').concat(` ${cardNumber.slice(-4)}`)
            : '';
        return (
            <form
                onSubmit={handleSubmit}
                className="bs-topUpForm"
            >
                <div className="bs-form__group">
                    <div className={`bs-form__field
                                     bs-topUpForm__field
                                     bs-topUpForm__field_cardNumber`}
                    >
                        <label
                            htmlFor="cardNumber"
                            className="bs-form__label bs-topUpForm__label"
                        >
                            Card number
                        </label>
                        <Field
                            name="cardNumber"
                            id="cardNumber"
                            component="input"
                            type="text"
                            placeholder={formattedCardNumber}
                            className="bs-input bs-form__input"
                            disabled
                        />
                    </div>
                </div>
                <div className="bs-form__group">
                    <div className="bs-form__field bs-topUpForm__field">
                        <label
                            htmlFor="amount"
                            className="bs-form__label bs-topUpForm__label"
                        >
                            Deposit amount
                        </label>
                        <div className="bs-inputWrapper">
                            <span className="bs-topUpForm__currencySign">
                                {currencySign}
                            </span>
                            <Field
                                name="amount"
                                id="amount"
                                component="input"
                                type="tel"
                                pattern="[0-9\.]*"
                                placeholder="0.00"
                                onChange={validateAmountLength}
                                onBlur={this.onAmountBlur}
                                validate={validateAmount}
                                normalize={normalizeAmount}
                                maxLength="8"
                                className="bs-input bs-form__input bs-topUpForm__input"
                            />
                        </div>
                    </div>
                    <div className="bs-form__field bs-topUpForm__field">
                        <label
                            htmlFor="cv2"
                            className="bs-form__label bs-topUpForm__label"
                        >
                            *CV2 code
                        </label>
                        <Field
                            name="cv2"
                            id="cv2"
                            component="input"
                            type="tel"
                            pattern="[0-9]*"
                            onBlur={this.onCvvBlur}
                            validate={validateCvv}
                            maxLength="3"
                            className="bs-input bs-form__input bs-topUpForm__input"
                        />
                    </div>
                    <div className="bs-form__field bs-topUpForm__field bs-topUpForm__field_button">
                        <button
                            type="submit"
                            className="bs-btn bs-btn_major bs-topUpForm__button"
                        >
                            <span>Deposit</span>
                        </button>
                    </div>
                </div>
                <div className="bs-topUpForm__footnote">
                    *The CV2 Security Code refers to the last three&nbsp;<wbr />
                    digits written on the back of your card.
                </div>
            </form>
        );
    }
}

TopUpForm.defaultProps = {
    cardNumber: '',
};

TopUpForm.propTypes = {
    currencySign: PropTypes.string.isRequired,
    cardNumber: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
};

export default reduxForm({
    form: 'topUpForm',
})(TopUpForm);



// WEBPACK FOOTER //
// /src/js/common/topUp/components/TopUpForm.jsx